
  import * as storyblokRuntime$_5TMj0OECfapHYBwmhNOMVyfqT_45Y5CVcB1WWaB3C97M4 from '/codebuild/output/src2080415864/src/ark/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 420,
    "sm": 560,
    "md": 768,
    "lg": 1024,
    "xl": 1200,
    "xxl": 1536,
    "2xl": 1440
  },
  "presets": {},
  "provider": "storyblok",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 80
},
    providers: {
        ['storyblok']: { provider: storyblokRuntime$_5TMj0OECfapHYBwmhNOMVyfqT_45Y5CVcB1WWaB3C97M4, defaults: {"baseURL":"https://a.storyblok.com"} }
    }
  }
